module.exports = __webpack_public_path__ + "static/media/logo-ihomes.8bbacaa8.webp";